import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { colors, spacing } from '../../lib/theme';
import { cleanFirebaseId, getProgressFromGUID } from '../../lib/utils';

export class EpisodeProgressBar extends Component {
    shouldComponentUpdate(nextProps) { // to do personal values when logged in.
        const { podcastEpisode, personalValues } = this.props;
        const { audioInfo } = this.props.audioState;
        // const { currentEpisodeId } = this.props.audioPlayState;
        const currentlyPlaying = (audioInfo && audioInfo.guid == podcastEpisode.guid); // || (currentEpisodeId == podcastEpisode.guid);
        let updateBoolArray = 0;
        if (nextProps.audioState && nextProps.audioState !== audioInfo) {
            // return true;
            updateBoolArray++;
        }
        if (currentlyPlaying) {
            // return true;
            updateBoolArray++;
        }
        const guidCleaned = cleanFirebaseId(podcastEpisode.guid);
        if ((nextProps.personalValues && nextProps.personalValues[guidCleaned] !== personalValues[guidCleaned])) {
            // return true;
            updateBoolArray++;
        }
        if (updateBoolArray > 0) {
            return true;
        } else {
            return false;
        }
    }

    render() {
        const { podcastEpisode, personalValues } = this.props;
        // console.dir(podcastEpisode);
        const { audioInfo } = this.props.audioState;
        // const { playAudio, playProgress, currentEpisodeId } = this.props.audioPlayState;
        // const { playAudio, playProgress } = this.props.audioPlayState;
        // const currentlyPlaying = (audioInfo && audioInfo.guid == (podcastEpisode && podcastEpisode.guid)); // || (currentEpisodeId == (podcastEpisode && podcastEpisode.guid));

        let sliderValue;
        if (podcastEpisode && podcastEpisode.guid) {
            // const guidCleaned = cleanFirebaseId(podcastEpisode.guid);
            // if (currentlyPlaying && playAudio) {
            //     sliderValue = playProgress;
            // } else {
            //     sliderValue = personalValues && typeof personalValues[guidCleaned] !== 'undefined' && personalValues[guidCleaned].progress || 0;
            sliderValue = getProgressFromGUID(personalValues, podcastEpisode.guid)
            // }
        }

        return (
            <div>
                {podcastEpisode && podcastEpisode.guid &&
                    <div className='app-progress-bar'>
                        <div className='app-progress-bar-child'></div>
                    </div>
                    // <Slider style={{ margin: `${spacing('xs')}`, cursor: 'default' }} defaultValue={0} tipFormatter={null}
                    //     value={sliderValue} min={0} max={100} />
                }
                <style jsx>
                    {`
                    :global(.ant-slider-rail) {
                        background-color: #e8e8e8;
                    }
                    .app-progress-bar {
                        height: 4px;
                        background-color: #e8e8e8;
                        border-radius: 12px;
                    }
                    .app-progress-bar-child {
                        height: 4px;
                        border-radius: 12px;
                        background: ${colors.primary};;
                        width: ${sliderValue}%; // 50%;
                    }
                `}
                </style>
            </div>
        )
    }
}

EpisodeProgressBar.propTypes = {
    personalValues: PropTypes.object,
    audioState: PropTypes.object,
    audioPlayState: PropTypes.object,
    podcastEpisode: PropTypes.object.isRequired,
}

const mapStateToProps = (state) => {
    return {
        personalValues: state.personalValues,
        audioState: state.audioState,
        audioPlayState: state.audioPlayState,
    }
}

// export default EpisodeProgressBar
export default connect(mapStateToProps, null)(EpisodeProgressBar)

